import { FrcFirmado } from "../../shared/model/frc/frc-firmado.model";

/**
 * El historial del FRC firmado a mano (14/10/2026). Cada vez que alguien
 * sube el formato firmado —quien pidió y después quien autoriza— el anterior
 * no se borra: queda como evidencia y se puede ver. El que se presenta es el
 * último. Aquí se arma la lista que muestra la ventana del historial.
 */

/** Escapa lo que viene del servidor antes de ponerlo en el HTML de la ventana. */
export function escapaHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);
}

/** «2026-09-30 10:15» → «30/09/2026 a las 10:15». */
export function fechaLegible(f: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/.exec(f);
  if (!m) {
    return f;
  }
  return `${m[3]}/${m[2]}/${m[1]}` + (m[4] ? " a las " + m[4] : "");
}

/** Los dos botones del renglón: blancos con la tinta del COS, también en los temas. */
const BOTON =
  "padding:6px 12px;border:1px solid #b71c1c;border-radius:8px;background:#fff;color:#b71c1c;font-weight:600;cursor:pointer";

/**
 * Un renglón por archivo, del último al primero, como los manda el
 * servidor: quién lo subió, cuándo, el nombre del archivo y sus botones
 * «Ver» (`data-firmado` lleva su id) y «Descargar» (`data-descargar`, el
 * mismo id; desde el 15/10/2026, para que RH guarde la evidencia con su
 * nombre). El primero dice «Se presenta»; los demás, «Anterior».
 */
export function htmlHistorial(firmados: FrcFirmado[]): string {
  const renglones = firmados.map((f, i) => {
    const etiqueta = i === 0
      ? `<span style="padding:2px 9px;border-radius:999px;background:#dcfce7;color:#166534;font-size:12px;font-weight:600">Se presenta</span>`
      : `<span style="padding:2px 9px;border-radius:999px;background:#f1f5f9;color:#475569;font-size:12px;font-weight:600">Anterior</span>`;
    const quien = f.usuarioNombre ? escapaHtml(f.usuarioNombre) : "Sin nombre";
    const cuando = f.fecha ? " · " + escapaHtml(fechaLegible(f.fecha)) : "";
    const archivo = f.nombreArchivo ? escapaHtml(f.nombreArchivo) : "";
    return (
      `<li style="display:flex;flex-wrap:wrap;align-items:center;gap:12px;row-gap:8px;padding:10px 0;color:#475569;border-top:${i === 0 ? "0" : "1px solid #e2e8f0"}">` +
      `<div style="flex:1 1 220px;min-width:0;overflow-wrap:anywhere">` +
      `<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">${etiqueta}` +
      `<b style="font-weight:600;color:#253042">${quien}</b></div>` +
      `<div style="font-size:13px;font-weight:400;color:#475569;margin-top:3px">${archivo}${cuando}</div>` +
      `</div>` +
      `<div style="display:flex;gap:6px;flex-shrink:0;margin-left:auto">` +
      `<button type="button" data-firmado="${f.idFirmado}" style="${BOTON}">Ver</button>` +
      `<button type="button" data-descargar="${f.idFirmado}" style="${BOTON}">Descargar</button>` +
      `</div>` +
      `</li>`
    );
  });
  return (
    `<p style="margin:0 0 8px;text-align:left;font-size:14px;font-weight:400;color:#475569">` +
    `Se presenta el último que se subió. Los anteriores se conservan como evidencia.</p>` +
    `<ul style="list-style:none;margin:0;padding:0;text-align:left">${renglones.join("")}</ul>`
  );
}
